export default {
  MEETING_API: 'https://6e84po1yji.execute-api.us-east-1.amazonaws.com/demo',
  WSS: 'wss://bmxw6fgzq0.execute-api.us-east-1.amazonaws.com/demo',
  SIGNED_API: 'https://a4p3kt7t0h.execute-api.us-east-1.amazonaws.com/demo',
  STREAM_API: 'https://qb7khwdzf7.execute-api.us-east-1.amazonaws.com/demo',
  LOG_LEVEL: 'error',
  QUESTIONS_CF_API: 'https://d2d4em0vr5cmjd.cloudfront.net',
};
